export default __webpack_public_path__ + "static/canderson-d700d0892ec05bae9563c5c8df881a31.png";